module.exports = __webpack_public_path__ + "static/media/teaching.00cffd4b.png";